import PropTypes from "prop-types";
import { markdown } from "../../../../helpers/markdown";
import { previewMarkdown } from "../../helpers/cellPreview";

// TODO markdown escapes colored text
function Text({ value, property = {}, options = {} }) {
  if (property.multiline) {
    // Table layout: compact plain-text preview instead of a full prose block.
    if (options.truncate) {
      return <div className="break-words">{previewMarkdown(value)}</div>;
    }
    return (
      <div
        className="prose break-words"
        dangerouslySetInnerHTML={{
          __html: markdown(value),
        }}
      />
    );
  }
  return <div className="truncate">{value}</div>;
}

Text.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  property: PropTypes.shape({ multiline: PropTypes.bool }),
  options: PropTypes.shape({ truncate: PropTypes.bool }),
};
export default Text;
